import React from "react";
import "rc-time-picker/assets/index.css";
import TimePicker from "rc-time-picker";
import * as moment from "moment";

export default ({
  label,
  value,
  onChange,
  disabled = false,
  className = "xxx",
}) => {
  return (
    <div className="formField">
      <TimePicker
        label={label}
        disabled={disabled}
        showSecond={true}
        value={value ? moment(value) : null}
        className={className}
        onChange={onChange}
        use12Hours
        inputReadOnly
      />
    </div>
  );
};
